import { useEffect, useState } from "react";
import Indicator from "../base/Indicator";
import { ExtensionCompact } from "../../modules/voice/pbx/models/Extension";
import FlexRow from "../base/FlexRow";
import { useHub } from "../../core/Global";
import { CallStateSnapshot, SipPhoneManager } from "../../core/SipPhoneManager";


interface TransferCallProps {
    call: CallStateSnapshot
    phone: SipPhoneManager
    onTransfered: (ext: ExtensionCompact) => void;
}
export default function TransferCall(props: TransferCallProps) {

    const hub = useHub()
    const [loading, loadingSet] = useState(true)
    const [model, modelSet] = useState<ExtensionCompact[]>([])

    const [tranfering, transferingSet] = useState(false)

    useEffect(() => {
        hub.Get("/system/Extensions/GetOnlineExts", res => {
            if (res.success && res.data) {
                modelSet(res.data);
                loadingSet(false);
            }
        })
    }, [])

    return (
        <div className="h-250px scroll-y w-100 my-2">
            {
                loading ? <Indicator />
                    :
                    <>
                        {
                            model.length == 0 && <div className="p-5 text-center">No online extensions</div>
                        }
                        {
                            model.map(ext => (
                                <FlexRow key={`transfer-ext-${ext.id}`} className="py-5 border-bottom">
                                    <div>{ext.name}</div>
                                    <button className="btn btn-sm btn-primary ms-auto" disabled={tranfering}
                                        onClick={async () => {
                                            transferingSet(true);
                                            await props.phone.blindTransferToExtension(props.call.id, ext.extensionNumber?.toString() ?? "0");
                                            props.onTransfered(ext);
                                        }}>
                                        Transfer
                                    </button>
                                </FlexRow>
                            ))
                        }
                    </>
            }
        </div>
    )
}